import React from 'react'
import MainContent from '../layouts/MainContent'
import MainMenu from '../layouts/MainMenu'
import MovedOrDeletedError from '../MoveOrDeletedError/MovedOrDeletedError'

const ProtectedRouteError = () => (
  <>
    <MainMenu />
    <MainContent>
      <MovedOrDeletedError />
    </MainContent>
  </>
)

// Named export for User Management unauthorized access handling
export const AccessDenied = ProtectedRouteError

export default ProtectedRouteError
